export default "__VITE_ASSET__58049b97__"